var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 21,
    viewBox: "0 0 40 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1H37L34 16H3L6 1Z",
    fill: "#E84855"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26725 14L9.81125 11.136C10.1633 9.264 10.4033 7.488 10.5473 6.4H10.5793C10.6913 7.744 10.7873 8.48 11.1233 9.984L11.9873 14H13.6993L15.7633 3.216H14.0353L13.5073 6.016C13.1713 7.808 12.9793 9.664 12.8353 10.848H12.8033C12.7233 9.952 12.5473 8.928 12.2753 7.504L11.4433 3.216H9.61925L7.55525 14H9.26725ZM21.4341 7.536H19.0181L19.5461 4.976H22.0261L22.3781 3.216H17.8661L15.8021 14H20.5061L20.8581 12.224H18.1381L18.7301 9.232H21.0981L21.4341 7.536ZM25.1939 14L26.5859 10.64C27.2259 9.2 27.6099 7.936 27.9779 6.864H28.0099C27.8819 7.936 27.8179 9.2 27.8019 10.384V14H29.9139L33.7539 3.216H31.7859L30.2179 8.176C29.8979 9.248 29.5779 10.368 29.2899 11.536H29.2579C29.3699 10.32 29.4659 9.184 29.5139 8.032L29.6899 3.216H27.8659L25.9939 8.256C25.5939 9.36 25.2419 10.368 24.9699 11.536H24.9219C25.0499 10.368 25.1779 9.248 25.2739 8.064L25.6099 3.216H23.5299L23.1939 14H25.1939Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 40,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.d710dd2e.svg";
export { ForwardRef as ReactComponent };